function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M0 4a1 1 0 011-1h14a1 1 0 110 2H1a1 1 0 01-1-1zm0 4a1 1 0 011-1h14a1 1 0 110 2H1a1 1 0 01-1-1zm1 3a1 1 0 100 2h14a1 1 0 100-2H1z",
  fill: "#4F566B"
})));